<template>
  <div>
    <nav-bar></nav-bar>
    <template>
      <prenota></prenota>
    </template>
  </div>
</template>

<script>
import navBar from "../navbar/navbar.vue";
import prenota from "../prenota/prenota.vue";

export default {
  components: {
    navBar,
    prenota,
  },
};
</script>
